import styled from 'styled-components';

export const CardContainer = styled.div<{ $recommend?: boolean }>`
  position: relative;

  display: flex;
  padding: 20px 16px;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  align-self: stretch;

  border-radius: 16px;
  background: ${({ $recommend }) => ($recommend ? '#F2F2FF' : '#F7F8FC')};
`;

export const CardHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
`;

export const CardTitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  align-self: stretch;
`;

export const CardTitle = styled.div`
  color: #222;
  font-size: 18px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.36px;
`;

export const PriceWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  align-self: stretch;
`;

export const Price = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 4px;
  align-self: stretch;

  color: #222;
  font-size: 20px;
  font-weight: 700;
  line-height: 145%;
  letter-spacing: -0.4px;

  span {
    font-size: 14px;
    font-weight: 500;
    line-height: 145%;
    letter-spacing: -0.28px;
  }
`;

export const OriginPriceBox = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 4px;
  align-self: stretch;

  color: #222;
  font-size: 16px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.32px;
`;

export const OriginPrice = styled.div`
  color: #616161;
  text-decoration-line: line-through;
  font-size: 14px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.28px;
`;

export const OriginPricePercent = styled.div`
  color: #4228d6;
  font-weight: 700;
`;

export const CardBottom = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 24px;
  align-self: stretch;
`;

export const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  align-self: stretch;
`;

export const PlanDescription = styled.div`
  display: flex;
  padding: 4px 0;
  align-items: flex-start;
  gap: 4px;
  align-self: stretch;

  & > img {
    width: 20px;
    height: 20px;
  }
`;

export const PlanDescriptionText = styled.div<{ $isGray?: boolean }>`
  color: ${({ $isGray }) => ($isGray ? '#616161' : '#222')};
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.28px;
`;

export const PlanDesriptionBold = styled(PlanDescriptionText)`
  font-weight: 700;
`;

export const ViewMore = styled.div`
  border-bottom: 1px solid #4228d6;
  cursor: pointer;

  color: #4228d6;
  font-size: 12px;
  font-weight: 700;
  line-height: 145%;
  letter-spacing: -0.24px;
`;

export const ConfirmButton = styled.div<{ $recommend?: boolean }>`
  display: flex;
  padding: 12px 0;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  border-radius: 8px;
  cursor: pointer;

  color: #fff;
  text-align: center;
  font-size: 16px;
  font-weight: 500;
  line-height: 150%;
  letter-spacing: -0.32px;

  background: ${({ $recommend }) => ($recommend ? '#4228d6' : '#222')};

  &:hover {
    background: ${({ $recommend }) => ($recommend ? '#5944e5' : '#333')};
  }

  &:active {
    background: ${({ $recommend }) => ($recommend ? '#705ef2' : '#444')};
  }
`;

export const DropdownButton = styled.div`
  display: flex;
  padding: 10px 12px;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  border-radius: 8px;

  border: 1px solid #e1e2e4;
  background: #fff;
  cursor: pointer;
`;

export const DropdownButtonText = styled.div`
  flex: 1 0 0;
  color: #222;
  font-size: 16px;
  font-weight: 500;
  line-height: 150%; /* 24px */
  letter-spacing: -0.32px;
`;

export const Badge = styled.div`
  position: absolute;
  top: -15px;
  left: 16px;
  display: flex;
  align-items: center;
  justify-content: center;

  padding: 4px 12px;
  border-radius: 20px;
  background: #1f0a8a;

  color: #fff;
  font-weight: 700;
  font-size: 14px;
  line-height: 150%;
  letter-spacing: -0.28px;
  white-space: nowrap;

  &::after {
    content: '';
    position: absolute;
    left: 50%;
    bottom: -6px;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 7px solid transparent;
    border-right: 7px solid transparent;
    border-top: 10px solid #1f0a8a;
  }
`;
